exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3KjHyvZGRc_EnqhgTAoiHJ{width:340px}html[dir=ltr] ._1u__wJzaiLbDkuiYxcu4SU{margin:20px 0 20px 24px}html[dir=rtl] ._1u__wJzaiLbDkuiYxcu4SU{margin:20px 24px 20px 0}html[dir] ._2V4RmecOo921qLicyghJo7{padding:20px 24px;border-top:1px solid \"[theme:neutralLighter, default:#f4f4f4]\"}._3e5GKSOFibil4nTQzGS4-5{font-weight:600;font-size:14px}html[dir] ._3e5GKSOFibil4nTQzGS4-5{margin-bottom:12px}._1HKlGqoINOBqrOiiB8vnAq{color:\"[theme:themePrimary, default:#0078D4]\";cursor:pointer}html[dir] ._1HKlGqoINOBqrOiiB8vnAq{background-color:transparent}html[dir] ._3f0MRdhfrlUMx2zrbohjEP{margin-top:3px}html[dir=ltr] ._3f0MRdhfrlUMx2zrbohjEP{float:left}html[dir=rtl] ._3f0MRdhfrlUMx2zrbohjEP{float:right}._15WARQbpLndiLJZybTBTGi{width:244px;vertical-align:middle}html[dir=ltr] ._15WARQbpLndiLJZybTBTGi{float:left;margin-left:12px;text-align:left}html[dir=rtl] ._15WARQbpLndiLJZybTBTGi{float:right;margin-right:12px;text-align:right}._3a4OUz7VBsoa9brQ-2Djjq{clear:both}", ""]);

// exports
exports.locals = {
	"container": "_3KjHyvZGRc_EnqhgTAoiHJ",
	"persona": "_1u__wJzaiLbDkuiYxcu4SU",
	"cardSection": "_2V4RmecOo921qLicyghJo7",
	"sectionHeader": "_3e5GKSOFibil4nTQzGS4-5",
	"linkToBing": "_1HKlGqoINOBqrOiiB8vnAq",
	"icon": "_3f0MRdhfrlUMx2zrbohjEP",
	"informationRow": "_15WARQbpLndiLJZybTBTGi",
	"clearFix": "_3a4OUz7VBsoa9brQ-2Djjq"
};